import { AxiosResponse } from 'axios';
import api from '__application-api__';
import { IMap } from '__components__/editor/EditorView/types/map.interface';

export default async (mapTranslateId: string): Promise<AxiosResponse<IMap>> => {
	return await api.EDITOR.mapDetail<IMap>({ mapTranslateId });
}
